import { useData } from 'contexts/data';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui/semantic-ui-imports';
import { groupAddons } from 'services/addons';
import { AddonOption } from 'Types/Aggregates';
import TextAndPicture from '../TextAndPicture';
import './index.scss';

function Automatics() {
  const { t } = useTranslation();

  const { activeUserInputs, availableAddons } = useData();

  const [addons, setAddons] = React.useState<AddonOption[]>([]);

  React.useEffect(() => {
    // Resolve addon IDs to full objects from availableAddons
    let resolvedAddons = activeUserInputs.addons;
    if (resolvedAddons?.length && availableAddons?.length) {
      const firstAddon = resolvedAddons[0];
      if (typeof firstAddon === 'number' || typeof firstAddon === 'string') {
        resolvedAddons = resolvedAddons
          .map((id: number | string) =>
            availableAddons.find((a) => a.id === Number(id))
          )
          .filter(Boolean);
      }
    }
    const cats = groupAddons(resolvedAddons, true);
    if (cats?.length) {
      setAddons(cats[0].addons);
    }
  }, [activeUserInputs.addons, availableAddons]);

  return (
    <div className="automatics">
      <Grid>
        <Grid.Row>
          <h2 className="automatics">
            {t(`resultsPage.automaticsComponent.header`)}
          </h2>
        </Grid.Row>

        {!!addons?.length &&
          addons.map((addon: AddonOption) => (
            <TextAndPicture
              key={addon.id}
              name={addon.name}
              text={addon.description}
              img={addon.image || ''}
              alt={addon.name}
            />
          ))}
      </Grid>
    </div>
  );
}

export default Automatics;
